function checkLocalStorageKey(){
    const localKey = localStorage.getItem('local_storage_key');
    if (localKey === null  || localKey !== process.env.VUE_APP_LOCAL_STORAGE_KEY) {
        localStorage.clear();
        localStorage.setItem('local_storage_key', process.env.VUE_APP_LOCAL_STORAGE_KEY);
    }
}

export { checkLocalStorageKey }
